import { SupplyRaws, Pagination } from '@factorin/domain';

import { withUrl, list } from '../rest';


interface SupplyRawListRequest extends Pagination.Request {
    batchUId?: string;
    supplyNumber?: string;
    additionalSupplyNumber?: string;
}

const cessionRawsPart = withUrl('supplyraws');

export const supplyraws = list<SupplyRaws.SupplyRaw, SupplyRawListRequest>(cessionRawsPart());
